import { useEffect, useRef } from "react";
import { useExperienceStore } from "../store/experience-store";

export function FinaleBrand(): React.JSX.Element {
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let previous = -1;
    const update = (state: ReturnType<typeof useExperienceStore.getState>): void => {
      const amount = state.chapterIndex === 6
        ? Math.min(1, Math.max(0, (state.chapterProgress - 0.18) / 0.58))
        : 0;
      const reveal = amount * amount * (3 - 2 * amount);
      if (reveal === previous) return;
      previous = reveal;
      rootRef.current?.style.setProperty("--finale-reveal", String(reveal));
      rootRef.current?.style.setProperty("--finale-shift", `${(1 - reveal) * 34}px`);
    };
    update(useExperienceStore.getState());
    return useExperienceStore.subscribe(update);
  }, []);

  return (
    <div ref={rootRef} className="finale-brand-lockup" aria-hidden="true">
      <img className="finale-brand-mark" src="./brand/showstrong-mark.png" alt="" />
      <img className="finale-brand-wordmark" src="./brand/showstrong-white.png" alt="" />
    </div>
  );
}
